import {createSelector} from 'reselect';
import {uniportalSelector} from 'modules/rootSelectors';

export const a11ycatStateSelector = createSelector(uniportalSelector, uniportal => uniportal.a11ycat || {});
export const titleSelector = createSelector(a11ycatStateSelector, state => state.title || '');
export const snapshotSelector = createSelector(a11ycatStateSelector, state => state.sendSnapshot || false);
export const scriptLoadedSelector = createSelector(a11ycatStateSelector, state => state.scriptLoaded || false);
